import styled from 'styled-components';
import { getApplication } from '../../services/BaseService';

const COLOR = getApplication() === 'tazama' ? 'var(--base-gray-90)' : 'white';

export const NotificationsStyle = styled.div`
  display: flex;
  flex-direction: column;

  .loading-cont {
    text-align: center;
    padding-top: var(--size);
    
    svg {
      color: ${COLOR};
    }
  }

  .notis-list {
    max-height: 40vh;
    overflow-y: auto;
    padding: 0px 12px 12px 12px;

    .no-notis {
      font-size: 14px;
      padding-top: var(--size);
      color: ${COLOR};
    }
  }
  
  .notis-title {
    display: flex;
    color: ${COLOR};
    padding: 12px 12px 0 12px;
    margin-bottom: 8px;

    h3 {
      color: ${COLOR};
      font-size: 18px;
      flex: 1;
      margin-bottom: 0px;
    }
  }

  .noti {
    display: flex;
    white-space: wrap;
    padding: var(--size) 0px;
    color: ${COLOR};
    border-bottom: 1px solid #384250;
    cursor: pointer;

    .not-read {
      .bullet {
        background: var(--color-primary-70);
        width: 8px;
        height: 8px;
        border-radius: 100%;
      }
    }

    .noti-main {
      flex: 1;
      display: flex;
      flex-direction: column;

      .noti-head {
        display: flex;

        h5 {
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 0px;
          color: ${COLOR};
          line-height: 20px;
          margin-right: 8px;
        }

        span {
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 0px;
          color: #9DA4AE;
          line-height: 20px;
        }
      }
    }

    label {
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 0px;
    }

    &:last-of-type {
      padding-bottom: 0px;
      border-bottom: 0px;
    }

    strong {
      color: ${COLOR};
    }

    &.clickable {
      cursor: pointer;
    }
  }

  &.app {
  }
`;
